module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vrassets/_next/static/images/front-cb37229c754163b73ab86e2e9735b924.png";